import { Nav, Collapse, Image, Row } from "react-bootstrap";
import { List } from "react-bootstrap-icons";
import NavItem from "../common/NavItem";
import React, { useEffect, useState } from "react";
import godrejLogo from "../../assets/godrej.svg";
import { MENUS } from "../../helpers/constants";
// import { userlogo } from "../../helpers/formatter";
import logoutarrow from "../../assets/logoutarrow.svg"
import { useMsal } from "@azure/msal-react";
import dashboard from "../../assets/dashboard.svg"
import transaction from "../../assets/transaction.svg"
import adminIcon from "../../assets/admin.svg"
import maintenance from "../../assets/maintenance.svg"
import reportIcon from "../../assets/report.svg"

export default function SideBar(props) {
  let icons = { "Transactions": transaction, "Admin": adminIcon, "Maintenance": maintenance, "Report": reportIcon }
  const [open, setOpen] = useState({});
  const [authorizedSessions, setAuthorizedSessions] = useState({});

  const { instance } = useMsal();

  function handleLogout(instance) {
    sessionStorage.clear()
    instance.logoutRedirect().catch((e) => {
      console.error(e);
    });
  }

  useEffect(() => {
    if (props.sidebar == "closed") {
      setOpen({})
    }
  }, [props.sidebar])

  const setMenu = () => {
    let authorizedSessionsTemp = {}
    let authorizedSessions = sessionStorage.getItem("AuthorizedSessions");

    try {
      if (authorizedSessions && authorizedSessions !== "" && authorizedSessions !== "[]") {
        authorizedSessions = JSON.parse(authorizedSessions);
        
        for (let key in MENUS) {
          if (authorizedSessions[key] && Array.isArray(authorizedSessions[key])) {
            // Only show menus where user has read access
            const accessibleMenus = authorizedSessions[key]
              .filter(item => item.read === true)
              .map((item2) => {
                const matchingItem = MENUS[key].find((item1) => item1.subMenu === item2.subMenu);
                if (matchingItem && matchingItem.path) {
                  return { ...item2, path: matchingItem.path };
                } else {
                  return item2;
                }
              })
              .filter(Boolean);
            
            if (accessibleMenus && accessibleMenus.length > 0) {
              authorizedSessionsTemp[key] = accessibleMenus;
            }
          }
        }
      }
      setAuthorizedSessions(authorizedSessionsTemp);
    } catch (error) {
      console.error('Error setting menu:', error);
      setAuthorizedSessions({});
    }
  }
  useEffect(() => {
    setMenu();
  }, [])


  return (
    <>
      <div className="sidebar-head">
        <List className="head-toggle" onClick={() => { props.setSidebar(props.sidebar === "closed" ? "open" : "closed") }}></List>

        <div className="user-section">
          <div className="user-logo">
            {/* {userlogo(sessionStorage.getItem("UserName"))} */}
          </div>
          <div className="user-info">
            <Row>
              <span className="user-name">{sessionStorage.getItem("UserName")}</span>
            </Row>
            <Row>
              <span className="user-email">{sessionStorage.getItem("Email")} </span>
            </Row>
          </div>
          <Image src={logoutarrow} onClick={(e) => handleLogout(instance)}></Image>

        </div>
      </div>
      <div className={`sidebar-body ${props.sidebar}`}>
        <Nav bsPrefix="nav-list" defaultActiveKey={"Dashboard"}>
          <NavItem menuType={"parent"} menu={"Dashboard"} path={"/"} icon={dashboard}></NavItem>
          {Object.keys(authorizedSessions).map((parentMenu, index) => {
            return <React.Fragment key={index}>
              {authorizedSessions[parentMenu].length > 0 ? <React.Fragment>
                <NavItem menuType={"parent"} menu={parentMenu} setOpen={setOpen} open={open} ariaControls={parentMenu} icon={icons[parentMenu]} setSidebar={props.setSidebar}></NavItem>
                <Collapse in={open[parentMenu]}>
                  <div id={parentMenu}>
                    {authorizedSessions[parentMenu].map((item, index) => {
                      return <React.Fragment key={index} > {item.Menu != false && <NavItem menuType={"menu"} menu={item.subMenu} path={item.path} setSidebar={props.setSidebar} ></NavItem>}</React.Fragment>
                    })}
                  </div></Collapse>
              </React.Fragment>
                : <></>
              }
            </React.Fragment>
          })}

        </Nav>
        <div className="footer">
          <Image className="footer-logo mt-auto" src={godrejLogo} />
        </div>
      </div>
    </>
  );
}
